module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-12day-premium-67689d16dcb8a22933d009213d7f2b56.webp";